module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_28.1d3c775e.mp3";